import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const getJobsList = createAsyncThunk(
    'jobs/getJobsList',
    async ({ accountId, token, search, start, length, jobStatusId, jobTypeId, customerId, noBilledJobs, systemTypeId }, { rejectWithValue }) => {
    try {
        // Log per debug paginazione
        console.log('[DEBUG PAGINATION] Parametri richiesta jobs:', { accountId, start, length, search });
        
        // NON APPLICHIAMO PIU' CORREZIONI ALLA PAGINAZIONE LATO FRONTEND
        // Lasciamo che il backend gestisca direttamente i parametri originali
        
        let url = `${import.meta.env.VITE_API_BASE_URL}/jobs/list?accountId=${accountId}&start=${start}&length=${length}&draw=1`;
        
        // Aggiungo i parametri di ricerca se presenti
        if (search && search.length > 0) {
            url += `&jobCode=${encodeURIComponent(search)}`;
        }
        
        // Aggiungo filtri opzionali
        if (jobStatusId) {
            url += `&jobStatusId=${jobStatusId}`;
        }
        
        if (jobTypeId) {
            url += `&jobTypeId=${jobTypeId}`;
        }
        
        if (customerId) {
            url += `&customerId=${customerId}`;
        }
        
        if (noBilledJobs !== undefined) {
            url += `&noBilledJobs=${noBilledJobs}`;
        }

        if (systemTypeId) {
            url += `&systemTypeId=${systemTypeId}`;
        }

        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token
            }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return rejectWithValue(errorData.message || 'Errore durante il recupero dei job');
        }
        
        const data = await response.json();
        
        // Log per debug paginazione: risposta API
        console.log('[DEBUG PAGINATION] Risposta API jobs:', { 
            recordsTotal: data.recordsTotal,
            recordsFiltered: data.recordsFiltered,
            dataCount: data.data ? data.data.length : 0,
            startIndex: start,
            endIndex: start + (data.data ? data.data.length : 0) - 1
        });
        
        return data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

export const getJobDetails = createAsyncThunk(
    'jobs/getJobDetails',
    async ({ jobId, token }, { rejectWithValue }) => {
    try {
        const url = `${import.meta.env.VITE_API_BASE_URL}/jobs?jobId=${jobId}`;
        
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'auth-token': token
            }
        });
        
        if (!response.ok) {
            const errorData = await response.json();
            return rejectWithValue(errorData.message || 'Errore durante il recupero dei dettagli del job');
        }
        
        const data = await response.json();
        return data.data;
    } catch (error) {
        return rejectWithValue(error.message);
    }
});

const jobsSlice = createSlice({
    name: 'jobs',
    initialState: {
        data: null,
        loading: false,
        error: null,
        jobDetails: null,
        loadingDetails: false,
        errorDetails: null
    },
    reducers: {
        resetJobDetails: (state) => {
            state.jobDetails = null;
            state.loadingDetails = false;
            state.errorDetails = null;
        }
    },
    extraReducers: (builder) => {
        builder
            // getJobsList
            .addCase(getJobsList.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(getJobsList.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
            })
            .addCase(getJobsList.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || 'Errore durante il recupero dei job';
            })
            // getJobDetails
            .addCase(getJobDetails.pending, (state) => {
                state.loadingDetails = true;
                state.errorDetails = null;
            })
            .addCase(getJobDetails.fulfilled, (state, action) => {
                state.loadingDetails = false;
                state.jobDetails = action.payload;
            })
            .addCase(getJobDetails.rejected, (state, action) => {
                state.loadingDetails = false;
                state.errorDetails = action.payload || 'Errore durante il recupero dei dettagli del job';
            });
    }
});

export const { resetJobDetails } = jobsSlice.actions;

export const selectJobsData = (state) => state.jobs.data;
export const selectJobsLoading = (state) => state.jobs.loading;
export const selectJobsError = (state) => state.jobs.error;
export const selectJobDetails = (state) => state.jobs.jobDetails;
export const selectJobDetailsLoading = (state) => state.jobs.loadingDetails;
export const selectJobDetailsError = (state) => state.jobs.errorDetails;

export default jobsSlice.reducer;
